module.exports = __webpack_public_path__ + "static/profilephoto-7998e502923a38a637b4fb0fa8c33665.png";